const ITEMS = ["Bridal Beauty", "Soft Glam", "Editorial Artistry", "Occasion Glam", "Mrinalee"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.concat(ITEMS).map((item, i) => (
      <span key={i} className="flex items-center">
        <span className={`font-serif-ed text-2xl sm:text-3xl px-8 whitespace-nowrap ${i % 2 ? "italic text-[#B8893B]" : "text-[#2A1F16]"}`}>
          {item}
        </span>
        <span className="h-1.5 w-1.5 rotate-45 bg-[#B8893B]/70" aria-hidden="true" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    aria-hidden="true"
    className="border-y border-[#E9DCC8] py-6 overflow-hidden select-none bg-[#FBF6EE]"
  >
    <div className="animate-marquee flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);
